module.exports = __webpack_public_path__ + "static/circlet_of_blasting-d8c556a571cdc8db45a12529d145b299.jpeg";